import type { BlockText } from 'shared-types';

type LocaleData = BlockText['locales'][string];

const defaultBlockData = {
  format: 'html' as const,
  textSize: 'normal' as const
};

const translatable: LocaleData['translatable'] = { text: '' };
const defaultLocaleData: LocaleData = { translatable };

const localePlaceholders = {
  text: '{{ locales.translatable.text }}' as const
};

export const defaults = {
  defaultBlockData,
  defaultLocaleData,
  localePlaceholders
};

export const blockTextData: BlockText = {
  ...defaultBlockData,
  ...localePlaceholders,
  locales: new Proxy({} as BlockText['locales'], {
    get: (locales, languageVersion: string) => {
      return (locales[languageVersion] = defaultLocaleData);
    }
  })
};
